var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-flex"},[_c('h1',{staticClass:"title"},[_vm._v("Herberg van het Hart")]),_vm._v(" "),_c('MainMenu',{attrs:{"page":_vm.page}})],1)]),_vm._v(" "),_c('div',{staticClass:"header-shadow"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d602d3b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainHeader.vue
// module id = TP09
// module chunks = 0